import { catchError } from 'rxjs/operators'
import { MatSnackBar } from '@angular/material/snack-bar'
import { of, OperatorFunction } from 'rxjs'
import { Inject, Injectable } from '@angular/core'
import { LocaleService } from 'framework/locale/services/locale.service'
import { RollbarService } from '../../../framework/rollbar/rollbar.service'
import * as Rollbar from 'rollbar'

export type ErrorMessageOptions = {
    message?: string
    actionText?: string | null
    actionFn?: Function | null
    duration?: number | null
}

export type ErrorCatcherOptions = ErrorMessageOptions & {
    catchFn?: Function
    failHard?: boolean
}

const defaultMessageOptions: ErrorCatcherOptions = {
    message: 'Oops, something went wrong',
    actionText: 'support',
    actionFn: function () {
        window.location.href = 'mailto:support@mistergreen.nl'
    },
    duration: null,
}

@Injectable()
export class ErrorService {
    constructor(
        @Inject(RollbarService) private rollbar: Rollbar,
        private snackBar: MatSnackBar,
        private localeService: LocaleService
    ) {
        if (this.localeService.language === 'nl') {
            defaultMessageOptions.message =
                'Oeps, er is iets mis gegaan, maar we weten niet precies wat. Neem daarom contact met ons op, dan zoeken we het z.s.m. voor je uit.'
            defaultMessageOptions.actionText = 'contact support'
        } else {
            defaultMessageOptions.message =
                "Oops, something went wrong, but we're not sure what exactly. Please contact us, we're very happy to help."
            defaultMessageOptions.actionText = 'contact support'
        }
    }

    createMessage(inputOptions: ErrorMessageOptions = {}) {
        const { message, actionText, actionFn, duration } = { ...defaultMessageOptions, ...inputOptions }
        const snackBarRef = this.snackBar.open(message, (!!actionFn && actionText) || undefined, { duration })

        if (!!actionFn && actionText) {
            snackBarRef.onAction().subscribe(() => {
                actionFn()
            })
        }
    }

    observableCatcher(inputOptions: ErrorCatcherOptions = {}): OperatorFunction<any, any> {
        const { catchFn, message, actionText, actionFn } = { ...defaultMessageOptions, ...inputOptions }

        return catchError((error, observable) => {
            let result = of(new Error(error))

            this.createMessage({ message, actionText, actionFn })

            try {
                if (catchFn) {
                    const catchFnResult = catchFn(error, observable)
                    if (catchFnResult) {
                        result = catchFnResult
                    }
                }
            } catch {}

            if (inputOptions.failHard) {
                throw new Error(error)
            }

            this.reportError(error)

            return result
        })
    }

    reportError(errorMessage: string) {
        console.error(errorMessage)
        this.rollbar.error(errorMessage)
    }
}
